import { TIME_GUTTER_CLASS } from '../constants';
import type { EventInstance } from '../types';
import { getEventColor } from '../utils';

interface AllDayRowProps {
  dayColumns: { date: Date; events: EventInstance[] }[];
  onClickEvent: (event: EventInstance) => void;
  eventColorPriority?: 'event' | 'calendar';
  /** Matches the time grid's reserved scrollbar gutter — see useScrollbarWidth. */
  scrollbarGutterPx?: number;
}

export function AllDayRow({
  dayColumns,
  onClickEvent,
  eventColorPriority = 'event',
  scrollbarGutterPx = 0,
}: AllDayRowProps) {
  const hasEvents = dayColumns.some((col) => col.events.length > 0);
  if (!hasEvents) return null;

  return (
    <div className="border-b flex" style={{ paddingRight: scrollbarGutterPx }}>
      {/* Hour label area */}
      <div
        className={`${TIME_GUTTER_CLASS} text-[10px] text-muted-foreground text-right pr-2 py-1`}
      >
        all-day
      </div>

      {/* Day columns */}
      <div
        className="flex-1 grid min-w-0"
        style={{ gridTemplateColumns: `repeat(${dayColumns.length}, minmax(0, 1fr))` }}
      >
        {dayColumns.map((col, i) => (
          <div
            key={i}
            className="border-r last:border-r-0 py-1 px-0.5 min-h-[28px] min-w-0 overflow-hidden"
          >
            {col.events.slice(0, 3).map((event) => (
              <button
                key={event.id}
                type="button"
                className="block w-full min-w-0 text-[10px] truncate rounded px-1 py-0.5 mb-0.5 cursor-pointer hover:opacity-80 text-white text-left"
                style={{ backgroundColor: getEventColor(event, eventColorPriority) }}
                onClick={() => onClickEvent(event)}
              >
                {event.title}
              </button>
            ))}
            {col.events.length > 3 && (
              <div className="text-[10px] text-muted-foreground px-1 truncate">
                +{col.events.length - 3} more
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
